import React, { useCallback, useRef, useState } from "react";
import { useHistory } from "react-router-dom";
import { AssetsReport } from "./AssetsDashboardComponents/AssetsReport";
import { AssetsTable } from "./AssetsDashboardComponents/AssetsTable";
import ModalVideo from "../ModuleVideos/ModalVideo";
import { LoadingOutlined } from "@ant-design/icons";
import "./AssetsDashboard.css";

export const AssetsDashboard = () => {
  const history = useHistory();
  const reportRef = useRef(null);
  const [sharedState, setSharedState] = useState(false);
  const [downloadLoading, setDownloadLoading] = useState(false);
  const [reportLoading, setReportLoading] = useState(false);

  const updateSharedState = useCallback((newState) => {
    setSharedState(newState);
  }, []);

  const handleNavigateToAddAsset = useCallback(() => {
    history.push("/asset_allocation");
  }, [history]);

  const handleDownloadReport = useCallback(() => {
    if (downloadLoading || reportLoading) return;
    if (reportRef.current && typeof reportRef.current.downloadPDF === "function") {
      reportRef.current.downloadPDF();
    }
  }, [downloadLoading, reportLoading]);

  const handleDownloadLoading = useCallback((loading) => {
    setDownloadLoading(loading);
  }, []);

  const handleReportLoadingChange = useCallback((loading) => {
    setReportLoading(loading);
  }, []);

  return (
    <div className="AssetsMain">
      <ModalVideo module="Assets" autoOpen={true} />
      <div className="assetscreate assetscreate--actions">
        <button className="addbuttonassets" onClick={handleNavigateToAddAsset}>
          + Add Asset
        </button>
        <button
          className={`addbuttonassets addbuttonassets--secondary assets-download-button${
            downloadLoading || reportLoading
              ? " addbuttonassets--loading"
              : ""
          }`}
          disabled={downloadLoading || reportLoading}
          onClick={handleDownloadReport}
          aria-busy={downloadLoading || reportLoading}
          aria-live="polite"
        >
          <span className="assets-download-icon-shell" aria-hidden="true">
            {downloadLoading || reportLoading ? (
              <LoadingOutlined
                className="assets-download-icon"
                style={{ color: "#ffffff" }}
                spin
              />
            ) : (
              <svg
                className="assets-download-icon assets-download-svg-icon"
                viewBox="0 0 24 24"
                fill="none"
                aria-hidden="true"
              >
                <path
                  d="M12 4.5V14.5"
                  stroke="currentColor"
                  strokeWidth="2.25"
                  strokeLinecap="round"
                />
                <path
                  d="M8.5 11.5L12 15L15.5 11.5"
                  stroke="currentColor"
                  strokeWidth="2.25"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M6 18.5H18"
                  stroke="currentColor"
                  strokeWidth="2.25"
                  strokeLinecap="round"
                />
              </svg>
            )}
          </span>
          {downloadLoading
            ? "Downloading..."
            : reportLoading
              ? "Preparing chart..."
              : "Download Report"}
        </button>
      </div>
      <div className="AssetsMainReport">
        <AssetsReport
          ref={reportRef}
          sharedState={sharedState}
          updateSharedState={updateSharedState}
          onDownloadLoading={handleDownloadLoading}
          onReportLoadingChange={handleReportLoadingChange}
        />
      </div>
      <div className="assetsTableCard">
        <AssetsTable
          sharedState={sharedState}
          updateSharedState={updateSharedState}
        />
      </div>
    </div>
  );
};
